import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, COLLECTION } from '@/plugins/sdk/fields'
import RateCard from '@/plugins/sdk/resources/RateCard'

export default class extends Resource {
  static name = 'ratesurcharge_rule'

  static get fields () {
    return {
      id: new UUID(),
      on: new STRING(),
      desc: new STRING(),
      expression: new STRING(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      rate_surcharges: new COLLECTION(RateCard)
    }
  }
}
